import { render, staticRenderFns } from "./HistoricoTecnico.vue?vue&type=template&id=2f3987b6&scoped=true&"
import script from "./HistoricoTecnico.vue?vue&type=script&lang=ts&"
export * from "./HistoricoTecnico.vue?vue&type=script&lang=ts&"
import style0 from "./HistoricoTecnico.vue?vue&type=style&index=0&id=2f3987b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3987b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2f3987b6', component.options)
    } else {
      api.reload('2f3987b6', component.options)
    }
    module.hot.accept("./HistoricoTecnico.vue?vue&type=template&id=2f3987b6&scoped=true&", function () {
      api.rerender('2f3987b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/AltaTecnico/HistoricoTecnico.vue"
export default component.exports